module.exports = __webpack_public_path__ + "img/Rectangle.83b78840.svg";